/**
 * @desc 内部调拨待报关报表导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.customsDeclarationApplyDetails.exportForOne.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationApplyDetails/exportForOne`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
